import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
    PENDING,
    VALIDATED,
    CANCELED,
    INSUFFICIENT_FOUND,
    WAITING_TRANSACTION
} from '../../../../services/checkout/constants';
import { PATH } from '../../../../constants/path';
import { MODAL_TYPE_KYC } from '../../../../services/modal/constants';
import { KYC_USE_CASE_WAITING_TRANSACTION } from '../../../../services/kyc/constants';
import { APPLICATION_ID, REDIRECT_URL } from '../../../../constants';

import { showModal } from '../../../../services/modal/actions';
import { fetchCheckoutDetails } from '../../../../services/checkout/actions';
import { fetchPaypalDetails } from '../../../../services/paypal/actions';
import { fetchEbonOrderByIdWithCode } from '../../../../services/ebon/actions';

import { useTracking } from '../../../../tracking/provider';

const ConfirmationEbonPageStateController = ({
    orderId,
    partnerId,
    partnerName,
    checkoutSessionId,
    paypalCost,
    paymentRef,
    setLoading,
    setKyc,
    kycValidated,
    ebonOrderState,
    setEbonOrderState,
    detailsInterval,
    sessionEmail,
    history,
    fetchingOrder,
    fetchingCheckoutDetails,
    checkoutDetails,
    fetchingPaypalDetails,
    paypalDetails,
    fetchEbonOrderByIdWithCode,
    fetchCheckoutDetails,
    fetchPaypalDetails,
    showModal
}) => {
    const [pendingInterval, setPendingInterval] = useState(null);

    const { gtm, ready } = useTracking();

    const fetchDetails = () => {
        if (checkoutSessionId) {
            fetchCheckoutDetails(orderId);
        } else if (!!paypalCost) {
            fetchPaypalDetails(paymentRef);
        }
    };

    /* Handle loading */
    useEffect(() => {
        if (
            fetchingOrder ||
            fetchingCheckoutDetails ||
            fetchingPaypalDetails ||
            !ebonOrderState ||
            ebonOrderState === PENDING
        ) {
            setLoading(true);
        } else {
            setLoading(false);
        }
    }, [fetchingOrder, fetchingCheckoutDetails, fetchingPaypalDetails, ebonOrderState]);

    /* Fetch order on display */
    useEffect(() => {
        fetchEbonOrderByIdWithCode(orderId);
    }, []);

    /* Fetch order state on display */
    useEffect(() => {
        fetchDetails();
    }, [checkoutSessionId, paypalCost]);

    /* Set order state */
    useEffect(() => {
        if (!!paypalCost) {
            return setEbonOrderState(paypalDetails);
        } else {
            return setEbonOrderState(checkoutDetails);
        }
    }, [checkoutDetails, paypalDetails]);

    /* Handle order states */
    useEffect(() => {
        if (!ebonOrderState || ebonOrderState === PENDING) {
            if (!pendingInterval) {
                setPendingInterval(
                    setInterval(() => {
                        fetchDetails();
                    }, 5000)
                );
                return () => {
                    clearInterval(pendingInterval);
                };
            }
        }

        if (!kycValidated && ebonOrderState && ebonOrderState === WAITING_TRANSACTION) {
            clearInterval(pendingInterval);
            clearInterval(detailsInterval);
            setKyc(true);
            showModal(MODAL_TYPE_KYC, {
                hideCloseButton: true,
                useCase: KYC_USE_CASE_WAITING_TRANSACTION
            });
        }

        if (ebonOrderState === CANCELED || ebonOrderState === INSUFFICIENT_FOUND) {
            clearInterval(pendingInterval);
            clearInterval(detailsInterval);
            history.push(`${PATH.EBON_ERROR_PATH}-${partnerId}?paiement=error&orderId=${orderId}`);
        }

        if (ebonOrderState === VALIDATED) {
            ready &&
                gtm.event('purchase', {
                    partner: { name: partnerName, id: partnerId },
                    orderId,
                    email: sessionEmail
                });
            clearInterval(pendingInterval);
            clearInterval(detailsInterval);

            if (REDIRECT_URL) {
                if (APPLICATION_ID === '142') {
                    setTimeout(() => {
                        window.location.href = REDIRECT_URL;
                    }, 10000);
                } else {
                    window.location.href = REDIRECT_URL;
                }
            }
        }
    }, [ebonOrderState]);

    return null;
};

ConfirmationEbonPageStateController.propTypes = {
    orderId: PropTypes.string,
    partnerName: PropTypes.string,
    partnerId: PropTypes.number,
    checkoutSessionId: PropTypes.string,
    paypalCost: PropTypes.string,
    paymentRef: PropTypes.string,
    setLoading: PropTypes.func,
    setKyc: PropTypes.func,
    kycValidated: PropTypes.bool,
    ebonOrderState: PropTypes.string,
    setEbonOrderState: PropTypes.func,
    detailsInterval: PropTypes.number,
    sessionEmail: PropTypes.string
};

const mapStateToProps = state => {
    return {
        fetchingOrder: state.ebon.fetchOrder,
        fetchingCheckoutDetails: state.checkout.fetchingDetails,
        checkoutDetails: state.checkout.details ? state.checkout.details.ebonOrderState : null,
        fetchingPaypalDetails: state.paypal.fetchingDetails,
        paypalDetails: state.paypal.details ? state.paypal.details.ebonOrderState : null
    };
};

const mapDispatchToProps = {
    fetchEbonOrderByIdWithCode,
    fetchCheckoutDetails,
    fetchPaypalDetails,
    showModal
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ConfirmationEbonPageStateController)
);



// WEBPACK FOOTER //
// ./src/components/pages/ebon/confirmation/ConfirmationEbonPageStateController.js